export const BASE_URL = 'template-sub-stages';

export const MOCK_UUID = '00000000-0000-4000-8000-000000000011';
